import { Trans, useTranslation } from 'react-i18next';
import { Heading } from '@lili/lili-frontend-common';
import { CustomRadioButton } from '@Components/inputs/RadioButton/CustomRadioButton';
import { ControllerWrapper } from '@Hooks/index';
import { CDD_VOLUME_OPTIONS } from './constants';
import { getCddVolumeOptionI18nKey } from './util';
import type { CddEmbeddedFields } from '../../eddQuestions/pages/direct/field.types';
import type { CddQuestionsKey } from './cddVolumesForm.types';

type SectionKey = 'achVolumes' | 'domesticWireVolumes' | 'internationalWireVolumes';

interface CddVolumesQuestionProps {
  sectionKey: SectionKey;
  fieldName: CddEmbeddedFields;
  contentKey: CddQuestionsKey;
}

export const CddVolumesQuestion = ({
  sectionKey,
  fieldName,
  contentKey,
}: CddVolumesQuestionProps) => {
  const { t } = useTranslation('cddQuestions');

  return (
    <>
      <Heading.H9 className='mb-4'>
        <Trans
          ns='cddQuestions'
          i18nKey={contentKey}
          components={{
            bold: <span className='font-[600]' data-tooltip-id='tooltip-business-address' />,
          }}
        />
      </Heading.H9>
      <div className='flex flex-col gap-4 mb-8'>
        <ControllerWrapper name={fieldName}>
          {({ onChange, value }) => (
            <>
              {CDD_VOLUME_OPTIONS.map((optionValue) => (
                <CustomRadioButton
                  key={optionValue}
                  label={t(
                    `${sectionKey}.options.${getCddVolumeOptionI18nKey(optionValue)}` as CddQuestionsKey
                  )}
                  value={optionValue}
                  onChange={onChange}
                  checked={value === optionValue}
                  name={optionValue}
                />
              ))}
            </>
          )}
        </ControllerWrapper>
      </div>
    </>
  );
};
